import React, {useRef, useState} from 'react';
import GisProvider from "./context/gis-context.jsx";
import Gis from "./gis.jsx";
import corporationService from "../../../services/web/corporation-service.js";
import {useQuery} from "@tanstack/react-query";
import {useMessageCount} from "../../../hooks/use-keep-session.js";
import {APIProvider, ControlPosition, Map, MapControl} from "@vis.gl/react-google-maps";
import {Template} from "../../../components/template/template.jsx";
import "./css/gis.css"
import {FaEnvelope} from "react-icons/fa";
import Button from "../../../components/button/button.jsx";
import {navigateHook} from "../../../hooks/use-navigate.js";

const GisIndex = ({sentryGrid}) => {
    const navigate = navigateHook();

    const [tempCardParams, setTempCardParams] = useState({});

    const tempCardActionRef = useRef(undefined);

    const messageCount = useMessageCount();

    const {data: corporation, isSuccess} = useQuery({
        queryFn: () => corporationService.entity(),
        queryKey: ["corporation"]
    });

    const latitude = parseFloat(corporation?.latitude) || 0;
    const longitude = parseFloat(corporation?.longitude) || 0;

    const position = {
        lat: latitude,
        lng: longitude
    }

    return (
        <Template>
            <Template.Header className={sentryGrid ? "hidden" : ""}>
                <Template.Title>Mapa em tempo real</Template.Title>

                <div className={"flex gap-2"}>
                    {
                        messageCount > 0 &&
                        <button type="button" className="cursor-pointer me-2 relative" onClick={() => navigate("/user-messages", true)}>
                            <FaEnvelope size={"24px"}/>
                            <div
                                className="absolute inline-flex items-center justify-center w-6 h-6 text-[11px] font-bold text-white bg-[var(--blue-bright)] rounded-full -top-1 -end-3">
                                {messageCount}
                            </div>
                        </button>
                    }

                    {
                        tempCardParams?.id &&
                        <div className="temp-card mr-2 flex gap-2">
                            {tempCardParams.id}
                            <span className="cursor-pointer" onClick={() => tempCardActionRef.current?.click()}>
                                <span className={"temp-close"} aria-hidden="true">&times;</span>
                            </span>
                        </div>
                    }
                </div>
            </Template.Header>
            <Template.Body className={`!p-0 h-[calc(100vh-57px)] ${sentryGrid ? "!mt-0" : ""}`}>
                {
                    !isSuccess &&
                    <div className="animate-pulse h-full">
                        <div className="h-full bg-gray-200"></div>
                    </div>
                }

                {
                    isSuccess &&
                    <APIProvider apiKey={corporation?.maps_api_key ?? ""}>
                        <Map
                            defaultZoom={12}
                            streetViewControl={true}
                            fullscreenControl={false}
                            defaultCenter={position}
                            gestureHandling={'greedy'}
                            style={{height: "100%", width: "100%"}}
                            mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                        >
                            <GisProvider sentryGrid={sentryGrid} tempCardParams={tempCardParams} setTempCardParams={setTempCardParams} tempCardActionRef={tempCardActionRef}>
                                <Gis/>
                            </GisProvider>
                        </Map>
                    </APIProvider>
                }
            </Template.Body>
        </Template>
    );
};

export default GisIndex;